import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Typography,
  Box,
  InputAdornment
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import brandService from '../../../../services/BrandService';
import categoryService from '../../../../services/categoryService';
import xmlDealerService from '../../../../services/xmlDealerService';
import useAlert from '../../../../hooks/useAlert';
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: theme.spacing(2, 0),
  backgroundColor: theme.palette.background.default,
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '& h2': {
    fontSize: '1.5rem',
    fontWeight: 'bold',
  }
}));

const AddXmlDialog = ({ open, onClose }) => {
  const [formData, setFormData] = useState({
    xmlDealerUserId: null,
    categoryId: null,
    brandId: null,
    productName: null,
    critialStock: 0,
    topPrice: 0,
    lowerPrice: 0,
  });
  const [users, setUser] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const { showErrorAlertAll, showSuccessAlertAll } = useAlert();
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const [xmlDealerShipId, setXmlDealerShipId] = useState(null);


  const handleChange = (name) => (event) => {
    setFormData({
      ...formData,
      [name]: event.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); 
    try {
      if (formData.xmlDealerUserId == null) {
        alert("Kullanıcı seçimi yapınız");
        return;
      } else {
        await xmlDealerService.addXml(formData);
        showSuccessAlertAll();
        onClose();
      }
    } catch {
      showErrorAlertAll();
    }
  };

  const fetchCategories = async () => {
    try {
      const isUpperCategorys = true;
      const response = await categoryService.getCategoriesApiForDropdown(null, 1, null, authUserId);

      const fetchedCategories = response.data?.data?.data.map(category => ({
        id: category.id,
        name: category.name,
        parentId: category.parentId || null,
      }));

      setCategories(fetchedCategories);
    } catch (error) {
      console.error("Kategoriler alınırken bir hata oluştu:", error);
    }
  };

  const fetchBrand = async () => {
    try {
      const response = await brandService.getBrandApi(authUserId, null);
      setBrands(response?.data?.data?.data);
    } catch (error) {
      console.error("Kategoriler alınırken bir hata oluştu:", error);
    }
  };

  const getXmlUser = async () => {
  
if(xmlDealerShipId>0){    var response = await xmlDealerService.fetchUsers(xmlDealerShipId);
  setUser(response?.data);}

  }
  useEffect(() => {

    const getShip = async () => {
      var response = await xmlDealerService.fetchDealerShip(authUserId);
      console.log("sadasdasd",response);
      setXmlDealerShipId(response?.data[0]?.id)
    }


    getShip();
  }, []);
  useEffect(() => {
    fetchBrand();
    fetchCategories();
    getXmlUser()
  }, [xmlDealerShipId])

  useEffect(()=>{
    setFormData({
      xmlDealerUserId: null,
      categoryId: null,
      brandId: null,
      productName: null,
      critialStock: 0,
      topPrice: 0,
      lowerPrice: 0,
    })
  },[open]);
  return (
    <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 2,
      }
    }}
  >
    {/* Custom Header */}
    <Box
      sx={{
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#fff',
        borderRadius: '8px 8px 0 0',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: 4, height: 24, backgroundColor: '#b71c1c', mr: 1 }} />
        <Typography
          variant="h6"
          sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}
        >
          XML Ekle
        </Typography>
      </Box>
    </Box>

    <DialogContent dividers>
      <form id="xml-form" onSubmit={(e) => e.preventDefault()}>
        {/* Required User Selection */}
        <FormControl fullWidth sx={{ mb: 4 }}>
          <InputLabel required>Kullanıcı Seç</InputLabel>
          <Select
            value={formData.xmlDealerUserId || ''}
            onChange={handleChange('xmlDealerUserId')}
            label="Kullanıcı Seç*"
          >
            {users?.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Filter Section */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" color="primary" sx={{ mb: 2 }}>
            Filtre Seçenekleri
          </Typography>
       
          
          <StyledPaper elevation={3}>
            <Grid container spacing={3}>
              {/* Category & Brand Selection */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Kategori</InputLabel>
                  <Select
                    value={formData.categoryId}
                    onChange={handleChange('categoryId')}
                    label="Kategori"
                  >
                    <MenuItem value="">
                      <em>Tüm Kategoriler</em>
                    </MenuItem>
                    {categories?.map((category) => (
                      <MenuItem key={category.id} value={category.id}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Marka</InputLabel>
                  <Select
                    value={formData.brandId}
                    onChange={handleChange('brandId')}
                    label="Marka"
                  >
                    <MenuItem value="">
                      <em>Tüm Markalar</em>
                    </MenuItem>
                    {brands?.map((brand) => (
                      <MenuItem key={brand.id} value={brand.id}>
                        {brand.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Product Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Ürün İsmi"
                  value={formData.productName}
                  onChange={handleChange('productName')}
                  variant="outlined"
                />
              </Grid>

              {/* Critical Stock */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Kritik Stok"
                  type="number"
                  value={formData.criticalStock}
                  onChange={handleChange('critialStock')}
                  variant="outlined"
                  InputProps={{
                    inputProps: { min: 0 }
                  }}
                />
              </Grid>

              {/* Price Range */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Minimum Fiyat"
                  type="number"
                  value={formData.minPrice}
                  onChange={handleChange('lowerPrice')}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₺</InputAdornment>,
                    inputProps: { min: 0 }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Maksimum Fiyat"
                  type="number"
                  value={formData.maxPrice}
                  onChange={handleChange('topPrice')}
                  variant="outlined"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₺</InputAdornment>,
                    inputProps: { min: 0 }
                  }}
                />
              </Grid>
            </Grid>
          </StyledPaper>
        </Box>
      </form>
    </DialogContent>

    <DialogActions sx={{ padding: 2 }}>
      <Button
        onClick={onClose}
        variant="outlined"
        sx={{ borderRadius: 2 }}
      >
        İptal
      </Button>
      <Button
        type="submit"
        form="xml-form"
        variant="contained"
        sx={{ borderRadius: 2 }}
        onClick={handleSubmit}
      >
        Kaydet
      </Button>
    </DialogActions>
  </Dialog>
  );
};

export default AddXmlDialog;